import { render, staticRenderFns } from "./QuizEdit.vue?vue&type=template&id=ae44cb2e&scoped=true&"
import script from "./QuizEdit.vue?vue&type=script&lang=ts&"
export * from "./QuizEdit.vue?vue&type=script&lang=ts&"
import style0 from "./QuizEdit.vue?vue&type=style&index=0&id=ae44cb2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae44cb2e",
  null
  
)

export default component.exports